var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box, ButtonBase, Collapse, Typography } from "@mui/material";
import { useState } from "react";
var CollapsibleSection = function (_a) {
    var title = _a.title, summary = _a.summary, _b = _a.defaultOpen, defaultOpen = _b === void 0 ? false : _b, onOpen = _a.onOpen, children = _a.children;
    var _c = useState(defaultOpen), open = _c[0], setOpen = _c[1];
    var Chevron = open ? ExpandMoreIcon : ChevronRightIcon;
    return (_jsxs(Box, { children: [_jsxs(ButtonBase, __assign({ onClick: function () {
                    if (!open)
                        onOpen === null || onOpen === void 0 ? void 0 : onOpen();
                    setOpen(!open);
                }, "aria-expanded": open, sx: { width: '100%', justifyContent: 'flex-start', gap: '2px', py: 1, borderRadius: '4px', fontFamily: 'inherit' } }, { children: [_jsx(Typography, __assign({ variant: 'subtitle1', fontWeight: 500 }, { children: title })), summary && _jsx(Typography, __assign({ variant: 'body2', color: 'text.secondary', ml: 1 }, { children: summary })), _jsx(Chevron, { sx: { fontSize: 20, color: 'text.secondary' } })] })), _jsx(Collapse, __assign({ in: open, unmountOnExit: true }, { children: _jsx(Box, __assign({ pb: 1.5 }, { children: children })) }))] }));
};
export default CollapsibleSection;
